import { render, staticRenderFns } from "./store_binding.vue?vue&type=template&id=23c69fbc&scoped=true"
import script from "./store_binding.vue?vue&type=script&lang=js"
export * from "./store_binding.vue?vue&type=script&lang=js"
import style0 from "./store_binding.vue?vue&type=style&index=0&id=23c69fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c69fbc",
  null
  
)

export default component.exports